import { createRoutine } from 'redux-saga-routines';

export const fetchInventoryPackageOptions = createRoutine(
  'FETCH_INVENTORY_PACKAGE_OPTIONS'
);

export const fetchInventoryItemLocationZoneOptions = createRoutine(
  'FETCH_INVENTORY_ITEM_LOCATION_ZONE_OPTIONS'
);

export const fetchInventoryAvailabilityOptions = createRoutine(
  'FETCH_INVENTORY_AVAILABILITY_OPTIONS'
);
